<template>
    <label :class="{ 'checked': currentValue == id }">
        <input type="radio" :name="type" :value="value" @click="selected" />
        <span class="check" :class="{'radiobutton': isRadioButton}"></span>
        <img v-if="imgSrc" :src="imgSrc" />
        <div class="text">
            <slot></slot>
        </div>

        <div v-if="price" class="price">
            &euro; {{price}}
        </div>

        <div class="info-icon" v-if="info !== undefined" >
            <span class="mdi mdi-information-outline" v-b-popover.hover="info" :title="name"></span>
        </div>
    </label>
</template>

<script>
  import {EventBus} from '../../services/eventBus'

  export default {
    name: "info-check",
    props: {
      name: String,
      value: {},
      price: Number,
      imgSrc: String,
      info: String,
      id: Number,
      type: String,
      currentValue: {},
      mectype: String,
      code: String,
      standardChecked: {
          type: Boolean,
          default: false
      },
      mechanismId: Number,
      mechanismName: String,
      mechmotor: String,
      mectrans: String,
      vartrans: String,
      optrans: String,
      isRadioButton: Boolean
    },
    data () {
      return {
        isChecked: false
      }
    },
    methods: {
      sendSelected() {
/*        if (this.mechmotor === 'smeltlood') {
            console.log(this.mechmotor)
        } else {
            console.log(this.mechmotor)
        }*/
        if(this.type === 'mechanisme') {
          let MechObj = {
            parent: this.name,
            name: this.name,
            id: this.id,
            price: this.price,
            imgSrc: this.imgSrc,
            checked: this.isChecked,
            type: this.type,
            mectype: this.mectype,
            mectrans: this.mectrans
          };

          let VarObj = {

          }
          EventBus.$emit('MechSelected', MechObj);
          //EventBus.$emit('VariantSelected', VarObj);
          let valueToSend = {};
          if (this.isChecked === true) {
            valueToSend = this.value
          }
          //console.log(this.value)
          //alert('die')
          EventBus.$emit('radio-button::new-value', valueToSend, this.type);

        }
        if(this.type === 'variant') {
          let VarObj = {
            parent: this.name,
            name: this.name,
            id: this.id,
            price: this.price,
            imgSrc: this.imgSrc,
            checked: this.isChecked,
            type: this.type,
            code: this.code,
            mechanismId: this.mechanismId,
            mechanismName: this.mechanismName,
            mectype: this.mectype,
            mectrans: this.mectrans,
            mechmotor: this.mechmotor,
            vartrans: this.vartrans
          };
            let MechObj = {
                name: this.mechanismName,
                id: this.mechanismId,
                checked: true,
                mectype: this.mectype,
                mectrans: this.mectrans,
                type: "mechanisme"
            };

         if (this.mechmotor === 'smeltlood') {
             EventBus.$emit('MechSelected', MechObj);
             EventBus.$emit('radio-button::new-value', MechObj, 'mechanisme');
          }

          EventBus.$emit('VariantSelected', VarObj);

          let valueToSend = {};
          if (this.isChecked === true) {
              //console.log(this.value)
            valueToSend = this.value
          }
          EventBus.$emit('radio-button::new-value', valueToSend, this.type);
        }

        if(this.type === 'option') {
          let OptObj = {
            parent: this.name,
            name: this.name,
            id: this.id,
            price: this.price,
            checked: this.isChecked,
            type: this.type,
            mectrans: this.mectrans,
            code: this.code
          };

          EventBus.$emit('OptionSelected', OptObj);
          let valueToSend = {};
          if (this.isChecked === true) {
            valueToSend = this.value
          }
          EventBus.$emit('radio-button::new-value', valueToSend, this.type);
        }
      },
      selected() {
        let wasChecked = this.isChecked
        EventBus.$emit(this.type + '-radio')
        this.isChecked = !wasChecked
        this.sendSelected()
      },
      reset () {
        this.isChecked = false;
      }
    },
    mounted () {
      EventBus.$on('selectedCheck', this.sendSelected)
      EventBus.$on(this.type + '-radio', this.reset)

      //console.log('current: '+ this.currentValue)
      if (this.standardChecked || this.currentValue == this.id) {
         // this.selected()
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/elements/InfoCheck.vue